export default {
  contact_data: {},
  use_app: false,
}
